export enum LoginLoadingEnum {
  REGULAR,
  FB,
  GOOGLE,
  RESIDENT,
  RESET,
  NULL,
}
